module.exports = __webpack_public_path__ + "img/white-w-disc-w-case-opened-xbox.2e1858a9.svg";